import { all } from "redux-saga/effects";
import { FooterSagas }  from "../store/footer/saga";
import { HeaderSagas }  from "../store/header/saga";
import { SearchSagas }  from "../store/troubleShooting/search/saga";
import { ConnectintSagas }  from "../store/connectint/saga";
import { articleDetailSagas } from "../store/troubleShooting/articleDetail/saga";
import { AuthSaga } from "../store/auth/saga";
import { NonSubscriberSagas } from "../store/nonSubscriber/saga";



export function* rootSaga() {
    yield all([
        ...FooterSagas,
        ...SearchSagas,
        ...articleDetailSagas,
        ...HeaderSagas,
        ...ConnectintSagas,
        ...AuthSaga,
        ...NonSubscriberSagas
    ]);
 }